import axios from '../../../axios';
import FetchJobBoardCandidate from '../types/FetchJobBoardCandidate';
// import ViewCvResponse from '../types/ViewCvResponse';

export const fetchJobBoardCandidate = async (payload: FetchJobBoardCandidate) => {
  const response = await axios.post(
    '/candidatesearch/api/job-board-search-account/dice-candidate',
    payload
  );
  return response.data;
};
